import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FullScreenImageService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  private imageSourceSubject = new BehaviorSubject<string>('');

  isOpen$ = this.isOpenSubject.asObservable();
  imageSource$ = this.imageSourceSubject.asObservable();

  openFullscreen(imageSrc: string): void {
    this.imageSourceSubject.next(imageSrc);
    this.isOpenSubject.next(true);
  }

  closeFullscreen(): void {
    this.isOpenSubject.next(false);
  }
}
